module.exports = __webpack_public_path__ + "img/Abstract-support-participate.c3c5b465.svg";